export default __webpack_public_path__ + "static/media/clock.6e2cda39.png";